import axios from 'axios'
import { atom } from 'jotai'
import { atomWithQuery } from 'jotai/query'

const apiKey = process.env.REACT_APP_LOKALISE_API_TOKEN
const projectId = process.env.REACT_APP_LOKALISE_PROJECT_ID

export interface ITranslations {
    [id: string]: string
}

const idAtom = atom(1)

const getLokaliseDataFromApi = async (): Promise<ITranslations> => {
    // const config = {
    //     headers: {
    //         'x-api-token': apiKey,
    //     },
    // }

    // let base = 'https://murmuring-castle-14887.herokuapp.com/'

    // if (process.env.NODE_ENV !== 'production') {
    //     base = ''
    // }

    // const response = await axios.get(
    //     `${base}https://api.lokalise.com/api2/projects/${projectId}/translations?limit=1000`,
    //     config
    // )
    // const keys = await axios.get(
    //     `${base}https://api.lokalise.com/api2/projects/${projectId}/keys?limit=1000`,
    //     config
    // )

    // const translations: ITranslations = {}
    // // eslint-disable-next-line no-restricted-syntax
    // for (const val of keys.data.keys) {
    //     translations[val.key_name.web] = response.data.translations.find(
    //         (trans) => trans.key_id === val.key_id
    //     ).translation
    // }
    const response = await axios.get(
        `https://lokalise-foa-sandbox.azurewebsites.net/get?_=${Date.now()}`
    )
    return response.data
}

const getLokaliseData = atomWithQuery((get) => ({
    queryKey: ['lokalise', get(idAtom)],
    queryFn: async ({ queryKey: [,] }) => {
        const config = {
            headers: {
                'x-api-token': apiKey,
            },
        }

        let base = 'https://murmuring-castle-14887.herokuapp.com/'

        if (process.env.NODE_ENV !== 'production') {
            base = ''
        }

        const response = await axios.get(
            `${base}https://api.lokalise.com/api2/projects/${projectId}/translations`,
            config
        )
        const keys = await axios.get(
            `${base}https://api.lokalise.com/api2/projects/${projectId}/keys`,
            config
        )

        const translations: ITranslations = {}
        // eslint-disable-next-line no-restricted-syntax
        for (const val of keys.data.keys) {
            translations[val.key_name.web] = response.data.translations.find(
                (trans) => trans.key_id === val.key_id
            ).translation
        }
        return translations
    },
}))

export { getLokaliseData, getLokaliseDataFromApi }
